/*
 * @Description: getters 文件
 * @Author: 王振
 * @Date: 2021-07-06 16:22:19
 * @LastEditors: 王振
 * @LastEditTime: 2021-07-07 09:36:36
 */
const getters = {
  token: (state) => state.user.token,
  userInfo: (state) => state.user.userInfo,
};
export default getters;



// WEBPACK FOOTER //
// ./src/pages/system/store/getters.js